import DataTableInit from './datatable.js';

$(document).ready(function() {
    if($('.guests-data-table').length) {

        var dataTable = $('.guests-data-table').DataTable({
            processing: true,
            serverSide: true,
            language : {
                sLengthMenu: "Show _MENU_",
                emptyTable: "No Guests available"
            },
            ajax: window.site.guestsTableData,
            columns: [
                // { data: 'guests', name: 'visit_guest.first_name' },
                // { data: 'company', name: 'visit_guest.company'},
                // { data: 'visitsCount', name: 'visit_guest.first_name' },
                // { data: 'lastVisitDate', name: 'visit_guest.first_name' },
                // { data: 'current', name: 'visits.current' },
                // { data: 'type', name: 'visit_guest.first_name' },
                { data: 'guests', name: 'guests' },
                { data: 'company', name: 'company'},
                { data: 'visitsCount', name: 'visitsCount' },
                { data: 'lastVisitDate', name: 'lastVisitDate' },
                { data: 'current', name: 'current' },
                { data: 'type', name: 'type' },
            ],
            "fnDrawCallback":function(){
                DataTableInit.handlePaginationState();
                DataTableInit.addDropdownArrows();
                DataTableInit.makeRowsClickable();
                DataTableInit.addDropdownArrowsSelectbox();
            },
            "fnInitComplete":function() {
                DataTableInit.addSearchCross();
                DataTableInit.makeRowsClickable();
            },
            'createdRow': function( row, data, dataIndex ) {
                if(data.type == 'User') {
                    $(row).attr('data-href', window.site.url + '/guest/user/single/' + data.id);
                } else {
                    $(row).attr('data-href', window.site.url + '/guest/single/' + data.id);
                }
            }
        });

        DataTableInit.construct(dataTable);

        dataTable.order( [[ 3, 'desc' ]] ).draw();


    }
});


// WEBPACK FOOTER //
// ./guests-datatable.js